import React from 'react';

type EditIconProps = {
  className?: string;
  onClick?: () => void;
  size?: number;
  color?: string | undefined;
  strokeWidth?: number
};

const FacebookIcon = ({ color = '#292D32', size = 22, strokeWidth = 1.2, className, onClick }: EditIconProps) => (
  <svg width={size} height={size} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M22 11.0004C22 16.5561 17.8818 21.1491 12.5319 21.8944C12.0317 21.9638 11.5199 22 11.0004 22C10.4007 22 9.81186 21.9522 9.23841 21.8597C4.00028 21.0165 0 16.4751 0 11.0004C0 4.9252 4.9252 0 10.9996 0C17.074 0 22 4.9252 22 11.0004Z" fill="#1877F2" />
    <path d="M12.5323 8.83189V11.2282H15.4966L15.0273 14.4562H12.5323V21.8933C12.0321 21.9627 11.5203 21.9989 11.0008 21.9989C10.4011 21.9989 9.81224 21.9511 9.23879 21.8586V14.4562H6.50488V11.2282H9.23879V8.29621C9.23879 6.4772 10.7133 5.00195 12.5331 5.00195V5.00349C12.5384 5.00349 12.5431 5.00195 12.5485 5.00195H15.4974V7.79367H13.5705C12.9978 7.79367 12.5331 8.25844 12.5331 8.83112L12.5323 8.83189Z" fill="white" />
  </svg>


);

export default FacebookIcon;